<template>
  <header class="header">
    <div class="u-flex">
      <router-link to="/home">
        <img src="../assets/img/header-logo2.png" alt v-if="choosedValue === 's'" />
        <img src="../assets/img/header-logo.png" alt v-else />
      </router-link>
    </div>
    <div v-if="userInfo && token" class="u-flex">
      <router-link to="/home" class="link" :class="{ active: $route.path === '/home' }">{{ i18n.linkHome }}</router-link>
      <router-link to="/portal/job/list" class="link" :class="{ active: $route.path === '/portal/job/list' }">{{ i18n.linkEmploy }}</router-link>
      <router-link to="/portal/business" class="link" :class="{ active: $route.path === '/portal/business' }">{{ i18n.linkBusiness }}</router-link>
      <router-link to="/portal/recruit" class="link" :class="{ active: $route.path === '/portal/recruit' }">{{ i18n.linkTalentPool }}</router-link>
      <router-link to="/portal/lounge" class="link" :class="{ active: $route.path === '/portal/lounge' }">{{ i18n.linkBothMeetRoom }}</router-link>
      <!-- <a href="#" class="link">{{ i18n.link3 }}</a> -->
      <router-link
        to="/portal/information/list"
        class="link"
        :class="{ active: $route.path === '/portal/information/list' }"
      >{{ i18n.linkPolicyInfo }}</router-link>
      <router-link to="/portal/contactUs" class="link" :class="{ active: $route.path === '/portal/contactUs' }">{{ i18n.linkContactUs }}</router-link>
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          <img
            :src="accountDetail.avatar&&accountDetail.avatar.link"
            alt
            width="40"
            height="40"
            style="border-radius: 50%; margin-right: 10px;"
          />
          <!-- <span>您好，{{ userInfo.account }}</span>
          <i class="el-icon-arrow-down el-icon--right text-color-light"></i>-->
        </span>
        <el-dropdown-menu slot="dropdown">
          <div style="text-align:center;padding:5px; border-bottom:1px solid orange">您好，{{ userInfo.account }}</div>
          <el-dropdown-item v-if="userInfo.role_name==='individual'" command="individual">进入个人中心</el-dropdown-item>
          <el-dropdown-item v-else-if="userInfo.role_name==='company'" command="company">进入企业</el-dropdown-item>
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div v-else class="link-box">
      <router-link to="/home" class="link" :class="{ active: $route.path === '/home' }">{{ i18n.linkHome }}</router-link>
      <router-link to="/portal/job/list" class="link" :class="{ active: $route.path === '/portal/job/list' }">{{ i18n.linkEmploy }}</router-link>
      <router-link to="/portal/business" class="link" :class="{ active: $route.path === '/portal/business' }">{{ i18n.linkBusiness }}</router-link>
      <router-link to="/portal/recruit" class="link" :class="{ active: $route.path === '/portal/recruit' }">{{ i18n.linkTalentPool }}</router-link>
      <router-link
        to="/portal/lounge"
        class="link"
        :class="{ active: ['/portal/lounge','/portal/lounge/list'].includes($route.path)}"
      >{{ i18n.linkBothMeetRoom }}</router-link>
      <!-- <a href="#" class="link">{{ i18n.link3 }}</a> -->
      <router-link
        to="/portal/information/list"
        class="link"
        :class="{ active: $route.path === '/portal/information/list' }"
      >{{ i18n.linkPolicyInfo }}</router-link>
      <router-link to="/portal/contactUs" class="link" :class="{ active: $route.path === '/portal/contactUs' }">{{ i18n.linkContactUs }}</router-link>
      <div class="login-register u-m-l-20">
        <router-link to="/login" class="login-link">{{ i18n.login }}</router-link>
        <span class="u-font-16">/</span>
        <router-link to="/register" class="login-link">{{ i18n.register }}</router-link>
      </div>
    </div>
    <login ref="login"></login>
    <div class="lang-change-wrappper">
      <span class="lang-item" :class="{active:choosedValue==='s'}" @click="langTran('s')">简</span>
      <span style="margin:0 10px">/</span>
      <span class="lang-item" :class="{active:choosedValue==='t'}" @click="langTran('t')">繁</span>
    </div>
  </header>
</template>

<script>
import Login from './Login'
import elementLocale from 'element-ui/lib/locale'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'nav-header',
  data() {
    return {
      // lang: '',

      detail: {},
      choosedValue: 's'
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'langType', 'companyAccountDetail', 'individualAccountDetail']),
    i18n() {
      return this.$t('layoutHeader')
    },
    accountDetail() {
      const accountDetail = this.userInfo.role_name === 'individual' ? this.individualAccountDetail : this.companyAccountDetail
      return accountDetail
    }
  },

  created() {
    this.choosedValue = this.langType
    if (this.userInfo) {
      if (this.userInfo.role_name === 'individual') {
        if (!this.individualAccountDetail.avatar) {
          this.SetIndividualAccountDetail()
        }
      } else {
        if (!this.companyAccountDetail.avatar) {
          this.SetCompanyAccountDetail()
        }
      }
    }
  },

  methods: {
    ...mapActions(['SetLanguageType', 'SetCompanyAccountDetail', 'SetIndividualAccountDetail']),
    handleCommand(command) {
      if (command === 'company') {
        this.$router.push('/company/baseInfo')
        return
      }
      if (command === 'individual') {
        this.$router.push('/individual/individualInfo')
        return
      }
      this.$confirm('确定退出登录？', '操作提示', {
        type: 'warning'
      })
        .then(() => {
          this.$store.dispatch('LogOut').then(() => {
            this.$router.replace('/home')
          })
        })
        .catch(() => {})
    },
    handleLoginClick() {
      this.$refs.login.open()
    },

    langTran(val) {
      this.choosedValue = val
      this.$zh_tran(val)
      this.SetLanguageType(val)
    },
    // 设置语言
    setI18nLanguage(lang) {
      this.$global.setLanguage(lang)
      this.$i18n.locale = lang
      elementLocale.i18n((key, value) => {
        return this.$i18n.t(key, value)
      }) // 为了实现element插件的多语言切换
      // 设置i18n的默认语言
      // axios.defaults.headers.common['Accept-Language'] = lang; //设置ajax请求的语言
      document.querySelector('html').setAttribute('lang', lang) // 设置html的语言
      // this.show = true
      return lang
    }
  },
  components: {
    Login
  }
}
</script>

<style lang="scss">
.header {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2000;
  width: 100%;
  min-width: 1200px;
  height: 80px;
  padding: 0 calc((100vw - 1200px) / 2);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .home-link {
    &:hover {
      color: $primary-color;
    }
  }
  .el-dropdown {
    color: $text-color;
    margin-left: 30px;
    cursor: pointer;
  }
  .el-dropdown-link {
    display: flex;
    align-items: center;
  }
  .link-box {
    display: flex;
    align-items: center;
    height: 80px;
    position: relative;
  }
  .link {
    padding: 10px 15px;
    font-size: 16px;
    position: relative;
    border-bottom: 3px solid #fff;
    transition: color 0.2s, font-weight 0.2s;
    cursor: pointer;
    user-select: none;
    &:hover {
      color: $primary-color;
      font-weight: 700;
    }
    &.active {
      border-bottom: 3px solid $primary-color;
      color: $primary-color;
      font-weight: 700;
    }
  }
  .login-register {
    padding: 10px 0;
    border-bottom: 3px solid #fff;
  }
  .login-link {
    font-size: 16px;
    cursor: pointer;
    &:hover {
      color: $primary-color;
    }
  }
  .login-type-box {
    display: none;
    position: absolute;
    top: 60px;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 20px 12px 20px;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.2);
    color: $text-color;
  }
  .login-type {
    margin-top: 12px;
    white-space: nowrap;
    line-height: 1;
    display: block;
    cursor: pointer;
    &:hover {
      color: $primary-color;
    }
  }
}
.lang-change-wrappper {
  position: absolute;
  transform: translateY(-50%);
  right: 20px;
  top: 50%;
  font-size: 16px;
  .lang-item {
    cursor: pointer;
  }
  .active {
    color: $primary-color;
  }
}
.header-dropdown-menu {
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2) !important;
  .el-dropdown-menu__item {
    color: $text-color-secondary;
    line-height: 36px !important;
    width: 200px;
    &:hover,
    &:focus {
      background-color: #f5f7fa !important;
      color: $primary-color !important;
    }
  }
}
</style>
